import React from 'react'
import { IconChecked, IconUnChecked } from '../common/Icons'
import HouseRulesDialog from './HouseRulesDialog'

interface Props {
  hostId: string
  listingData: any
  isChecked: boolean
  toggleChecked: () => void
}
const CheckboxConfirmBooking: React.FC<Props> = ({ hostId, listingData, isChecked, toggleChecked }) => {
  return (
    <div className="px-4 md:px-0">
      <p className="mb-[12px] dtravel-grayscale-900 dtravel-inter-500 dtravel-text-14-20">Complete booking</p>
      <div className="flex items-start dtravel-gap-12">
        <button
          // className="cursor-pointer mt-[2px]"
          // role={'button'}
          // tabIndex={0}
          // onKeyUp={() => setCheckedConditions(!isCheckedConditions)}
          onClick={toggleChecked}
        >
          {isChecked ? <IconChecked /> : <IconUnChecked />}
        </button>
        <p className="dtravel-grayscale-600 dtravel-inter-400 dtravel-text-12-16">
          By completing this booking, you agree to the&nbsp;
          <a
            className="underline"
            href={`https://${process.env.REACT_APP_DOMAIN}/terms-and-conditions/${hostId}`}
            target={'_blank'}
            rel="noreferrer"
          >
            Terms and Conditions
          </a>
          &nbsp;and&nbsp;
          <a
            className="underline"
            href={`https://${process.env.REACT_APP_DOMAIN}/privacy-policy/${hostId}`}
            target={'_blank'}
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <>
            &nbsp;and&nbsp;
            <HouseRulesDialog propertyDetail={listingData} />
          </>
          .
        </p>
      </div>
    </div>
  )
}

export default CheckboxConfirmBooking
